export const isValidUrl = (url: string): boolean => {
  try {
    new URL(toHttpsUrl(url));
    return true;
  } catch (e) {
    return false;
  }
};

export const toHttpsUrl = (url?: string): string => {
  if (!url) return '';
  if (url.startsWith('http://')) {
    return 'https://' + url.slice(7);
  }
  if (url.startsWith('https://')) {
    return url;
  }
  return 'https://' + url;
};

export const truncateUrl = (url: string, maxLength = 50): string => {
  if (url.length <= maxLength) return url;
  try {
    const urlObj = new URL(toHttpsUrl(url));
    const domain = urlObj.hostname;
    const path = urlObj.pathname + urlObj.search + urlObj.hash;
    const domainLength = domain.length;
    if (domainLength >= maxLength - 3) {
      return domain.slice(0, maxLength - 3) + '...';
    }
    const remainingLength = maxLength - domainLength - 3;
    if (path.length <= remainingLength) {
      return domain + path;
    }
    return domain + path.slice(0, remainingLength) + '...';
  } catch {
    return url.length > maxLength ? url.slice(0, maxLength - 3) + '...' : url;
  }
};
